export const abiosConfigName: string = 'lvbet';
